"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomCustomTagName = void 0;
var getRandomString_1 = require("./getRandomString");
var getRandomCustomTagName = function (min, max) {
    if (min === void 0) { min = 1; }
    if (max === void 0) { max = 10; }
    return "".concat((0, getRandomString_1.getRandomString)(min, max), "-").concat((0, getRandomString_1.getRandomString)(min, max));
};
exports.getRandomCustomTagName = getRandomCustomTagName;
//# sourceMappingURL=getRandomCustomTagName.js.map